import React from 'react';
import { Box } from '@mui/material';
import Footer from '../layout/Footer';
import { SOCIAL_LINKS, SocialButton } from './SocialRail';

/**
 * Подвал главной. Раньше это была отдельная сцена: фоновый арт во всю ширину, заголовок
 * «Мы в социальных сетях» и сетка 2×2 из карточек по 320px. Соцсети уехали в плавающий
 * рейл у левого края (`SocialRail`), и вместе с ними ушла причина держать здесь и арт,
 * и трёхсотпиксельные отступы под него.
 *
 * Осталось ровно необходимое: контакты на узких экранах (где рейла нет) и общий футер.
 * Футер стоит в обычном потоке — держать его абсолютом больше не за чем, фоновой
 * картинки, поверх которой он лежал, больше нет.
 */
const HomeFooter: React.FC = () => (
  <Box component="footer" sx={{ position: 'relative' }}>
    <Box
      sx={{
        display: { xs: 'flex', lg: 'none' },
        // По центру, а не слева: строка общего футера под ними на узком экране тоже
        // центрируется, и левое прижатие читалось как сбой вёрстки
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: 1.5,
        maxWidth: '1400px',
        mx: 'auto',
        px: { xs: 2, md: 4 },
        pb: { xs: 3, md: 4 },
      }}
    >
      {SOCIAL_LINKS.map((item) => (
        <SocialButton key={item.id} item={item} size={44} />
      ))}
    </Box>

    <Footer />
  </Box>
);

export default HomeFooter;
